import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import CoEditionRequestList from "./CoEditionRequestList";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function CoEditionRequests() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(CoEditionRequestList, null))); } })));
}
export default CoEditionRequests;
